import { useLocation } from "react-router-dom";
import { useConsentBannerVisible } from "@/components/AnalyticsConsentBanner";

export function FloatingActions() {
  const location = useLocation();
  const consentVisible = useConsentBannerVisible();

  if (
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/oauth/") ||
    location.pathname === "/bio"
  )
    return null;

  return (
    <a
      href="https://wa.me/5538988467524?text=Ol%C3%A1!%20Gostaria%20de%20negociar%20um%20projeto."
      target="_blank"
      rel="noopener noreferrer"
      title="Negociar via WhatsApp"
      aria-label="Negociar via WhatsApp"
      style={{ bottom: consentVisible ? 110 : 26 }}
      // Verde oficial do WhatsApp (marca de terceiro) — única cor literal permitida aqui.
      // eslint-disable-next-line no-restricted-syntax
      className="fixed right-6 z-50 flex h-[54px] w-[54px] items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-8px_rgba(37,211,102,.6)] transition-[bottom] duration-200"
    >
      <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.65-2.05-.17-.3-.02-.46.13-.6.13-.14.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.38-.02-.53-.08-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.01-1.04 2.47s1.06 2.86 1.21 3.06c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35Z" />
        <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5.05-1.32A10 10 0 1 0 12 2Zm0 18.2a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-3 .78.8-2.92-.2-.3A8.2 8.2 0 1 1 12 20.2Z" />
      </svg>
    </a>
  );
}
